var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_281_1279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9C18.5 4.02947 14.4705 0 9.5 0C4.52947 0 0.5 4.0294 0.5 9C0.5 13.4921 3.79119 17.2155 8.09375 17.8907V11.6016H5.80859V9H8.09375V7.01719C8.09375 4.76156 9.43742 3.51562 11.4931 3.51562C12.4779 3.51562 13.5078 3.69141 13.5078 3.69141V5.90625H12.373C11.2549 5.90625 10.9062 6.60002 10.9062 7.3118V9H13.4023L13.0033 11.6016H10.9062V17.8907C15.2088 17.2155 18.5 13.4922 18.5 9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0033 11.6016L13.4023 9H10.9062V7.3118C10.9062 6.59995 11.2549 5.90625 12.373 5.90625H13.5078V3.69141C13.5078 3.69141 12.4779 3.51562 11.4931 3.51562C9.43742 3.51562 8.09375 4.76156 8.09375 7.01719V9H5.80859V11.6016H8.09375V17.8907C8.55895 17.9636 9.02912 18.0001 9.5 18C9.97088 18.0001 10.4411 17.9636 10.9062 17.8907V11.6016H13.0033Z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_281_1279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3046462e278d38251c4c1f28f360bb87.svg";
export { ForwardRef as ReactComponent };